import { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { money } from "./common";

export default function CustomersAdmin() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/admin/customers").then((r) => setData(r.data)).catch(() => {});
    }, []);

    if (!data) return <p className="text-slate-500">Loading customers…</p>;

    const Row = ({ c, testId }) => (
        <div className="flex items-center gap-4 p-4 flex-wrap" data-testid={testId}>
            <div className="h-10 w-10 rounded-full bg-[#0033A0] text-white flex items-center justify-center font-heading font-bold shrink-0">
                {(c.name || c.email)[0].toUpperCase()}
            </div>
            <div className="flex-1 min-w-40">
                <p className="font-heading font-bold text-slate-900">{c.name || "—"}</p>
                <p className="text-xs text-slate-500">{c.email}</p>
            </div>
            <p className="text-sm text-slate-600">{c.orders} order{c.orders !== 1 ? "s" : ""}</p>
            <p className="font-heading font-extrabold text-[#0033A0]">{money(c.spent)}</p>
            {c.marketing_consent && <span className="rounded-full bg-[#40E0D0]/30 text-[#0033A0] text-xs font-bold px-2 py-0.5">Marketing ✓</span>}
        </div>
    );

    return (
        <div data-testid="admin-customers" className="space-y-8">
            <div>
                <h2 className="font-heading font-extrabold text-lg text-slate-900 mb-3" data-testid="customers-accounts-heading">
                    Registered accounts ({data.accounts.length})
                </h2>
                <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100" data-testid="customers-accounts">
                    {data.accounts.length === 0 && <p className="p-6 text-sm text-slate-400">No registered customers yet.</p>}
                    {data.accounts.map((c) => (
                        <Row key={c.id} c={c} testId={`customer-${c.id}`} />
                    ))}
                </div>
            </div>
            <div>
                <h2 className="font-heading font-extrabold text-lg text-slate-900 mb-3" data-testid="customers-guests-heading">
                    Guest customers ({data.guests.length})
                </h2>
                <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100" data-testid="customers-guests">
                    {data.guests.length === 0 && <p className="p-6 text-sm text-slate-400">No guest orders yet.</p>}
                    {data.guests.map((c) => (
                        <Row key={c.email} c={c} testId={`guest-${c.email}`} />
                    ))}
                </div>
            </div>
        </div>
    );
}
